
import React from 'react';
import {Popup} from "../../../../../ui/popup/popup";
import ProductPriceFormat from "../../../product-price/product-price-format";
import {rootActions, useAppDispatch, useAppSelector} from "../../data-services/store";

const PRDPriceSubscriptionPlanPopup = () => {

    const PlanPricePopupShown = useAppSelector((store) => store.PlanPricePopupShown);
    const PlanPriceSavePopupShown = useAppSelector((store) => store.PlanPriceSavePopupShown);
    const dispatch = useAppDispatch();

    const closePopup = () => {
        dispatch(
            rootActions.main({
                IsSubscriptionPlanPopupShown: false,
                PlanPricePopupShown: null,
                PlanPriceSavePopupShown: null
            })
        );
    };

    return (
        <Popup width="320px" height="200px" close={ closePopup }>
            <div className="prd-price-subscription-plan-popup flex flex-col justify-center items-center w-full h-full text-center text-gray-700">
                <p className="mb-4">By paying <ProductPriceFormat price={ PlanPricePopupShown ?? 0 } /> upfront annually, you save <ProductPriceFormat price={ PlanPriceSavePopupShown ?? 0 } />  compared to paying monthly.</p>
                <button className="w-btn w-auto px-10" type="button" onClick={ closePopup }>OK</button>
            </div>
        </Popup>
    )
};

export default PRDPriceSubscriptionPlanPopup;